import React, { createContext, useContext, useState } from 'react';

const SessionContext = createContext();

export function SessionProvider({ venueId, tableNumber, checkoutId, children }) {
  const [sessionToken, setSessionToken] = useState(null);
  const [member, setMember] = useState(null);

  return (
    <SessionContext.Provider value={{ venueId, tableNumber, checkoutId, sessionToken, setSessionToken, member, setMember }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  return useContext(SessionContext);
}
